<template>
  <div>
    <div class="clearfix"></div>
    <div class="banner" @click="handleCloseMenu">
      <white-menu ref="whiteMenu"></white-menu>
      <section class="section section-lg my-0 font-class">
        <div class="login-title">
          <div class="f_spec_sc-R">Sign In & REGISTER</div>
        </div>
        <div class="login-wrapper">
          <div class="login-box">
            <div class="tabbar">
              <div class="circle" @click="tabeChange(0)" :class="activeIndex==0?'active':''">Sign In</div>
              <div
                class="circle"
                @click="tabeChange(1)"
                :class="activeIndex==1?'active':''"
              >Creare Account</div>
            </div>
            <div class="line"></div>
            <!-- 账号登录 -->
            <div v-show="activeIndex == 0">
              <form ref="loginForm">
              <div class="child-title">Sign In with Email</div>
              <div class="line-division">
                <div class="line-division1"></div>
                <div class="line-division2"></div>
                <div class="line-division3"></div>
              </div>
              <div>
                <div class="input-title input-title-left1">Email*</div>
                <div class="input-box input-title-left1 input-box-width3">
                  <input class="input form-control" type="text" v-model="loginForm.email" />
                </div>
              </div>
              <div>
                <div class="input-title input-title-left1">Password*</div>
                <div class="input-box input-title-left1 input-box-width3">
                  <input class="input form-control" type="password" v-model="loginForm.password" ref="password" />
                  <div class="icon-eye" v-show="showPassword" @click="handleShowPassword(false)">
                    <img :src="require('@/assets/login/View_alt.png')" alt="">
                  </div>
                  <div class="icon-eye" v-show="!showPassword" @click="handleShowPassword(true)">
                    <img :src="require('@/assets/login/View_hide_fill.png')" alt="">
                  </div>
                </div>
              </div>
              <div class="input-title-left1 forget-password" @click="handleForgotPwd">Forget password?</div>
              <div class="checkbox-top checkbox-left tabbar" @click="checkClick('login')">
                <div v-show="loginForm.isRead == 1">
                  <img src="../../src/assets/login/Group 42.png" alt />
                </div>
                <div v-show="loginForm.isRead == 0">
                  <img src="../../src/assets/login/Ellipse 144.png" alt />
                </div>
                <div
                  class="icheckbox-left"
                >Keep me signed in.</div>
              </div>
              <div class="login-wrapper">
                <div class="buttom1 login-buttom login-bottom1" @click="emailLogin">Sign Up</div>
              </div>
              </form>
              <div class="child-title">Sign In with Social</div>
              <div class="line-division">
                <div class="line-division1"></div>
                <div class="line-division2"></div>
                <div class="line-division3"></div>
              </div>
              <div class="login-wrapper">
                <div class="buttom1" @click="googleLogin">
                  <img src="../../src/assets/login/Group.png" style="margin-right: 10px;" alt />Sign up with Google
                </div>
                <div class="buttom1 login-bottom2" @click="facebookLogin">
                  <img src="../../src/assets/login/Frame 87.png" style="margin-right: 10px;" alt />Sign up with Facebook
                </div>
              </div>
            </div>
            <!-- 创建账号 -->
            <div v-show="activeIndex == 1">
              <div class="child-title">Register with Social</div>
              <div class="line-division">
                <div class="line-division1"></div>
                <div class="line-division2"></div>
                <div class="line-division3"></div>
              </div>
              <div class="login-wrapper">
                <div class="buttom1" @click="googleLogin">
                  <img src="../../src/assets/login/Group.png" style="margin-right: 10px;" alt />Sign up with Google
                </div>
                <div class="buttom1" @click="facebookLogin">
                  <img src="../../src/assets/login/Frame 87.png" style="margin-right: 10px;" alt />Sign up with Facebook
                </div>
              </div>
              <div class="child-title">Register with Email</div>
              <div class="line-division">
                <div class="line-division1"></div>
                <div class="line-division2"></div>
                <div class="line-division3"></div>
              </div>
              <div class="tabbar">
                <div>
                  <div class="input-title input-title-left1">First Name*</div>
                  <div class="input-box input-title-left1 input-box-width1">
                    <input class="input form-control" type="text" v-model="registerForm.firstName" />
                  </div>
                </div>
                <div>
                  <div class="input-title input-title-left2">Last Name*</div>
                  <div class="input-box input-title-left2 input-box-width2">
                    <input class="input form-control" type="text" v-model="registerForm.lastName" />
                  </div>
                </div>
              </div>
              <div>
                <div class="input-title input-title-left1">Email*</div>
                <div class="input-box input-title-left1 input-box-width3">
                  <input class="input form-control" type="text" v-model="registerForm.email" />
                </div>
              </div>
              <div>
                <div class="input-title input-title-left1">Password*</div>
                <div class="input-box input-title-left1 input-box-width3">
                  <input class="input form-control" type="password" v-model="registerForm.password" />
                </div>
                <div class="input-title-left1 password-notice">
                  Password must be at least 8 characters,include at least 1 character and 1 number
                </div>
              </div>
              <div>
                <div class="input-title input-title-left1">Confirm Password*</div>
                <div class="input-box input-title-left1 input-box-width3">
                  <input class="input form-control" type="password" v-model="registerForm.confirmPassword" />
                </div>
              </div>
              <div class="checkbox-top checkbox-left tabbar" @click="checkClick('register')">
                <div v-show="registerForm.isRead == 1">
                  <img src="../../src/assets/login/Group 42.png" alt />
                </div>
                <div v-show="registerForm.isRead == 0">
                  <img src="../../src/assets/login/Ellipse 144.png" alt />
                </div>
                <div
                  class="icheckbox-left"
                >Sign-up to receive access to new releases and events from ViaWatch.</div>
              </div>
              <div
                class="checkbox-top input-title-left1"
              >By clicking Sign Up, you agree to our Terms & Conditions and Privacy Policy.</div>
              <div class="login-wrapper" @click="createAccount">
                <div class="buttom1 login-buttom login-bottom2">Sign Up</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import WhiteMenu from "@/components/WhiteMenu";
import { validateEmail, validatePassword } from "@/utils/validate.js"
import store from "@/store"
import {register, googleLogin, loginGoogle, facebookLogin, loginFacebook, checkAccount} from "@/api/login"

export default {
  name: "LoginView",
  components: {
    WhiteMenu//引入头部控件
  },
  data() {
    // 声明变量
    return {
      activeIndex: 0,
      showPassword: false,
      loading: false,
      loginForm: {
        email: '',
        password: '',
        isRead: false,
      },
      registerForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: "",
        confirmPassword: "",
        isRead: false,
        basePath: '',
      }
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        console.log('watch login router: ', route)
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.registerForm.basePath = window.location.protocol + '//' + window.location.host
    console.log(this.$route)
    if (this.$route.query && this.$route.query.code) {
      // 标识谷歌或facebook字段的
      if (this.$route.query.scope && this.$route.query.scope.indexOf('google') > 0) {
        loginGoogle(this.$route.query.code).then(response => {
          console.log(response)
          if (response.data.errno == 0 &&　response.data.data) {
            let data = response.data.data
            this.$store.dispatch('LoginByThirdParty', data)
            console.log('google login set token after:', this.redirect)
            this.$router.push({ path: this.redirect || '/' }, () => {})
          }

        }).catch(err => {
          console.log(err)
        })
      } else if (this.$route.query.state) {
        loginFacebook(this.$route.query.code).then(response => {
          console.log(response)
          if (response.data.errno == 0 &&　response.data.data) {
            let data = response.data.data
            this.$store.dispatch('LoginByThirdParty', data)
            this.$router.push({ path: this.redirect || '/' }, () => {})
          }

        }).catch(err => {
          console.log(err)
        })
      }
    }

    // 注册邮件跳转
    if (this.$route.query && this.$route.query.checkAccount) {
      checkAccount(this.$route.query.checkAccount).then(response => {
        this.success('验证email成功')
      }).catch(err => {
        console.log(err)
        this.error('验证email失败')
      })
    }

  },
  methods: {
    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu")
      if (!sp.contains(event.target)) {
      	this.$refs.whiteMenu.searchFocus = false;
      	this.$refs.whiteMenu.isHovered = false;
      }
    },
    tabeChange(val) {
      this.activeIndex = val;
    },
    checkClick(val) {
      if (val == 'login') {
        this.loginForm.isRead = !this.loginForm.isRead;
      } else if (val == 'register') {
        this.registerForm.isRead = !this.registerForm.isRead;
      }

    },
    emailLogin(){
      // alert(this.email+this.password);
      if (!this.loginForm.email.trim() || !this.loginForm.password) {
        this.error('必填字段，不能为空')
        return
      }
      if (!validateEmail(this.loginForm.email)) {
        this.error('无效的email')
        return
      }

      if (!this.loading) {
        this.loading = true

        this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
          this.loading = false
          this.$router.push({ path: this.redirect || '/' }, () => {})
          // sessionStorage.setItem()
          console.log(sessionStorage)
          console.log(this.$store.getters.token)
        }).catch(response => {
          this.loading = false
          console.log('login fail', response)
        })
      } else {
        return false
      }
    },
    createAccount(){
      console.log('开始注册')
      var bb=this.valid(this.registerForm)
      if(!bb){
        return
      }

      if (!this.loading) {
        register(this.registerForm).then(response=>{
          this.loading = false
          console.log(response.data)
          if (response.data.errno == 0 && response.data.data) {
            this.success('注册成功，请在10分钟之内完成邮箱验证')
          }
        }).catch(response=>{
          this.loading = false
          console.log(response.data)
        })
      }
    },
    googleLogin(){
      googleLogin().then(response => {
        console.log('response: ', response)
        if (response.data.errno == 0 && response.data.data) {
          window.location.href = response.data.data
        }
      }).catch((err) => {
        console.log('err: ', err)
      })
    },
    facebookLogin(){
      facebookLogin().then(response => {
        console.log('response: ', response)
        if (response.data.errno == 0 && response.data.data) {
          window.location.href = response.data.data
        }
      }).catch((err) => {
        console.log('err: ', err)
      })
    },
    error(msg) {
      this.$message({
        message: msg,
        type: 'error',
        offset: 80
      })
    },
    success(msg) {
      this.$message({
        message: msg,
        type: 'success',
        offset: 80
      })
    },
    handleShowPassword(bool) {
      this.showPassword = bool;
      if (bool) {
        this.$refs.password.type = 'text';
      } else {
        this.$refs.password.type = 'password';
      }
    },
    handleForgotPwd() {
      this.$router.push({
        name: 'resetPassword'
      })
    },
    valid(that){
     if(that.firstName===''){
        alert('first name不能为空')
        return false
     }
     if(that.lastName===''){
        alert('last name不能为空')
        return false
     }
     if(that.email===''){
        alert('email不能为空')
        return false
     }
     if (!validateEmail(that.email)) {
        alert('无效的email')
        return false
     }
     if(that.password===''){
        alert('password不能为空')
        return false
     }
     if(that.password.length < 8){
        alert('password不能少于8个字符')
        return false
     }
     if (!validatePassword(that.password)) {
        alert('password至少有一个字母和一个数字')
        return false
     }
     if(that.confirmPassword===''){
        alert('confirm password不能为空')
        return false
     }
     if(that.password !== that.confirmPassword){
        alert('失败: 两次密码不一致')
        return false
     }
     if(!that.isRead){
       alert('请勾选同意框')
       return false
     }
     return true
   }

  },
  beforeRouteEnter(to, from, next) {
    next()
    return
    console.log('token', store.getters.token);
    if (store.getters.token) {
      next({ path: '/' })
    } else {
      next(vm => {
        console.log(vm)
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log('login before route update')
    next()
  },
  beforeRouteLeave(to, from, next) {
    console.log('login before route leave')
    next()
  }
}
</script>

<style scoped>
.font-class {
  font-family: 'Spectral-Bold';
}
.login-title {
  font-size: 32px;
  font-weight: 250;
  margin-top: 6rem;
  text-align: center;
  margin-bottom: 1.2rem;
  font-weight: 400;
}
.input-title {
  font-size: 16px;
  margin-top: 25px;
  margin-bottom: 14px;
}
.input-title-left1 {
  margin-left: 50px;
}
.input-title-left2 {
  margin-left: 27px;
}
.icheckbox-left {
  margin-left: 15px;
}
.input-box {
  height: 47px;
}
.input-box-width1 {
  width: 362px;
}
.input-box-width2 {
  width: 380px;
}
.input-box-width3 {
  width: 770px;
}
.checkbox-left {
  margin-left: 64px;
}
.checkbox-top {
  margin-top: 30px;
}
.input {
  height: 100%;
  width: 100%;
  border-radius: 5px;
  border: 1px solid black;
  font-family: spectral-R;
  color: black;
}
.icon-eye {
  position: relative;
  float: right;
  margin-top: -2rem;
  margin-right: 0.8rem;
  z-index: 99999;
}
.forget-password {
  font-size: 0.875rem;
  color: #59657A;
  text-decoration: underline;
  margin-top: 0.125rem;
  cursor: pointer;
}
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.line {
  width: 100%;
  height: 1px;
  background: black;
}
.login-box {
  width: 878px;
  display: flex;
  border: 1px solid black;
  flex-direction: column;
}
.login-box {
  margin: 50px;
  cursor: default;
}
.tabbar {
  display: flex;
}
.child-title {
  font-size: 20px;
  margin-top: 37px;
  margin-left: 44px;
}
.line-division {
  display: flex;
  margin-top: 13.6px;
  height: 2px;
  flex-direction: row;
}
.line-division1 {
  margin-left: 42px;
  width: 162px;
  height: 100%;
  background: #000;
}
.line-division2 {
  margin-left: 11px;
  width: 64px;
  height: 100%;
  background: #000;
}
.line-division3 {
  margin-left: 11px;
  width: 37px;
  height: 100%;
  background: #000;
}
.buttom1 {
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  width: 770px;
  height: 47px;
  margin-top: 23px;
  cursor: default;
}
.buttom1:hover {
  background: #24385D;
  color: white;
}
.login-buttom {
  margin-top: 63.28px;
  background: black;
  color: #fff;
}
.login-bottom1{
  margin-bottom: 59px;
}
.login-bottom2{
  margin-bottom: 83px;
}
.circle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 21px;
  flex: 1;
  height: 69px;
  cursor: pointer;
}
.circle.active {
  background: #24385D;
  color: #fff;
  cursor: default;
}
.step .contact {
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.password-notice {
  padding-left: 18px;
  padding-top: 6px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/LoginView.vue